// src/utils/downloadHandlers.ts
import { toast } from "react-toastify";
import { downloadInvoiceFile } from "./downloadHelper";
import { downloadInvoice, downloadReceipt } from "../services/selfService";

interface DownloadOptions {
  onStart?: () => void;
  onSuccess?: () => void;
  onError?: (error: any) => void;
  onFinally?: () => void;
}

export const downloadInvoiceHandler = async (invoiceNumber: string, options?: DownloadOptions) => {
  options?.onStart?.();

  try {
    const response = await downloadInvoice(invoiceNumber);

    if (response.data) {
      downloadInvoiceFile(response.data, invoiceNumber, "invoice");
      toast.success("Invoice downloaded successfully");
      options?.onSuccess?.();
    }
  } catch (error: any) {
    toast.error(error.data?.message || "Failed to download invoice");
    options?.onError?.(error);
  } finally {
    options?.onFinally?.();
  }
};

export const downloadReceiptHandler = async (
  invoiceNumber?: string,
  receiptNumber?: string,
  options?: DownloadOptions
) => {
  options?.onStart?.();

  try {
    // Ensure at least one identifier is provided and use only one of it to download the receipt
    if (!invoiceNumber && !receiptNumber) {
      toast.error("Invoice or receipt number not found");
      return;
    }
     const  receiptId = invoiceNumber || receiptNumber;
    // 3. Build payload with ONLY the selected one
    const payload = invoiceNumber ? { invoiceNumber:receiptId } : { receiptNumber: receiptId };


    const response = await downloadReceipt(payload);

 
    if (response.data) {
      downloadInvoiceFile(response.data, receiptId!, "receipt");
      toast.success("Receipt downloaded successfully");
      options?.onSuccess?.();
    }
  } catch (error: any) {
    toast.error(error.data?.message || "Failed to download receipt");
    options?.onError?.(error);
  } finally {
    options?.onFinally?.();
  }
};
